module.exports = __webpack_public_path__ + "static/media/комната гг 7.fa2ff288.jpg";